<style>
.subject {
  color: #FFF;
  font-family: Kanit;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

}

.arrow-right {
  width: 0;
  height: 0;
  border-top: 60px solid transparent;
  border-bottom: 60px solid transparent;
  border-left: 60px solid green;
}

@media screen and (max-width: 768px) {
  .subject {
    width: 529px;
  }
}

@media screen and (min-width: 769px) {
  .subject {
    width: 100%;
  }
}

@media screen and (max-width: 1024px) {
  .subject {
    width: 791px;
  }
}

@media screen and (min-width: 1025px) {
  .subject {
    width: 971px;
  }
}

@media screen and (min-width: 1201px) {
  .subject {
    width: 100%;
  }
}
</style>
<template>
  <v-content pa-0>
    <Header></Header>
    <div style="position: relative;display: flex;justify-content: center;align-items: center"
      :style="$vuetify.breakpoint.mdAndUp ? { 'padding-top': '88px' } : {}">
      <v-img style="width: 100%" max-height="500px"
        :src="$vuetify.breakpoint.smAndDown ? http + homeMainBanner.mobile_img : http + homeMainBanner.desktop_img"></v-img>
    </div>
    <!-- <div v-if="homeBanner.length > 0" class="ma-0 pa-0" style="margin-bottom: -6px !important"> -->
    <!-- <img src="https://data.cea.or.th/service/uploads/image/banners/banner_633f9d73d0e6e.jpg" alt="" width="100%" height="auto"> -->
    <!-- <MultiBanner :banner="homeBanner"></MultiBanner> -->
    <!-- </div> -->
    <loading :active.sync="isLoading"></loading>
    <v-flex xs12>
      <v-layout justify-start>
        <v-flex class="headTab" px-5 py-3>
          <img :src="require('../assets/icon/report_orange.png')" class="mx-5" height="35px" width="auto" />
          <div class="text-start">
            {{ $t("country-power-bi-topic") }}
          </div>
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <span v-for="(item, i) in powerBiDataOverviewCountry" :key="i">
          <div style="display: grid; justify-items: center;  margin-top: 20px;">
            <div class="subject"
              style="background: var(--gradient-1, linear-gradient(90deg, #EF5322 50%, #711B00 103.83%));text-align: left;display: flex;align-items: center ; padding: 16px 12px;">
              <svg style="margin-right: 10px;" xmlns="http://www.w3.org/2000/svg" width="29px" height="29px"
                viewBox="0 0 512 512">
                <g transform="rotate(90 256 256)">
                  <path fill="#d9d9d9" d="M256 32L20 464h472L256 32z" />
                </g>
              </svg>
              <p class="subject m-0" v-if="language == 'en'">{{ item.subject_en }} </p>
              <p class="subject m-0" v-else>{{ item.subject_th }} </p>
            </div>
          </div>
          <div :class="item.description_en && item.description_th ? ' py-5' : ''" class="row ma-0 pa-0 mt-5 ">
            <v-flex v-if="language == 'en'" xs12>
              <PowerBiPanel :embed_url="item.embed_url_en"></PowerBiPanel>
            </v-flex>
            <v-flex v-else xs12>
              <PowerBiPanel :embed_url="item.embed_url_th">
              </PowerBiPanel>
            </v-flex>
          </div>
        </span>
      </v-flex>
      <v-layout justify-start>
        <v-flex class="headTab" px-5 py-3>
          <v-icon class="mx-5" color="#FF5100" large>bar_chart</v-icon>
          <div class="text-start">
            {{ $t("international-power-bi-topic") }}
          </div>
        </v-flex>
      </v-layout>
      <v-flex xs12>
        <span v-for="(item, i) in powerBiDataOverviewInternational" :key="i">
          <div style="display: grid; justify-items: center; margin-top: 20px;">
            <div class="subject"
              style="background: var(--gradient-1, linear-gradient(90deg, #EF5322 50%, #711B00 103.83%));text-align: left;display: flex;align-items: center ; padding: 16px 12px;">
              <svg style="margin-right: 10px;" xmlns="http://www.w3.org/2000/svg" width="29px" height="29px"
                viewBox="0 0 512 512">
                <g transform="rotate(90 256 256)">
                  <path fill="#d9d9d9" d="M256 32L20 464h472L256 32z" />
                </g>
              </svg>
              <p class="subject mb-0" v-if="language == 'en'">{{ item.subject_en }} </p>
              <p class="subject mb-0" v-else>{{ item.subject_th }} </p>
            </div>
          </div>
          <div :class="item.description_en && item.description_th ? 'py-5' : ''" class="row ma-0 pa-0 mt-5 ">
            <v-flex v-if="language == 'en'" xs12>
              <PowerBiPanel :embed_url="item.embed_url_en"></PowerBiPanel>
              <!-- <template v-if="item.description_en">
                {{ item.description_en }}
              </template> -->
            </v-flex>
            <v-flex v-else xs12>
              <PowerBiPanel :embed_url="item.embed_url_th"></PowerBiPanel>
              <!-- <template v-if="item.description_th">
                {{ item.description_th }}
              </template> -->
            </v-flex>
          </div>
        </span>
        <!--          <Footer></Footer>-->
      </v-flex>
      <!-- Articles -->
      <!-- <v-layout justify-start mb-4>
        <v-flex class="headTab" px-5 py-3>
          <img :src="require('../assets/icon/report_orange.png')" class="mx-5" height="35px" width="auto" />
          <div class="text-start">
            {{ $t("related-research-report") }}
          </div>
        </v-flex>
      </v-layout> -->
      <v-layout justify-center>
        <v-flex xs12>
          <ReportGroup :list="articles" group="overview"></ReportGroup>
        </v-flex>
      </v-layout>
    </v-flex>
    <Footer></Footer>

    <v-dialog content-class="overflow-dialog" width="900"></v-dialog>
  </v-content>
</template>

<script>
</script>
<script>
import {mapActions, mapState} from "vuex";
import {domain} from "../services/Constants";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PowerBiPanel from "../components/PowerBIPanel";
import Service from "../services";
import Loading from "vue-loading-overlay";
import ReportGroup from "../components/ReportGroup";
import MultiBanner from "./MultiBanner";
import "vue-loading-overlay/dist/vue-loading.css";
import * as pbi from "powerbi-client";
import $ from "jquery";

export default {
  name: "home",
  components: {
    Header,
    Footer,
    Loading,
    ReportGroup,
    MultiBanner,
    PowerBiPanel,
  },
  data: () => ({
    http: domain,
    isLoading: true,
    output: null,
    interPowerBiTopic: false,
    countryPowerBiTopic: false,
    articles: [],
    interData: {},
    countryData: {},
  }),
  computed: {
    ...mapState({
      homeBanner: (state) => state.banner.overviewBanner,
      homeMainBanner: (state) => state.banner.homeMain,
      dataAndStatsBanner: (state) => state.banner.dataAndStatsBanner,
      // powerBiEmbed: (state) => state.power_bi.powerBiDataOverviewInternational,
      powerBiDataOverviewInternational: (state) => state.power_bi.powerBiDataOverviewInternational,
      powerBiDataOverviewCountry: (state) => state.power_bi.powerBiDataOverviewCountry,
      language: (state) => state.locale.language,
    }),

  },
  watch: {
    language: function () {
      // Force reload
      this.isLoading = true;
      this.$nextTick(() => {
        this.isLoading = false;
      });
    },
  },
  async created() {
    await this.$store.dispatch("banner/onGetAllBanners").then(res => {
      if (res) {
        console.log("loadBanner Success")

      }
    });
    await this.$store.dispatch("power_bi/onGetAllPowerBi");
    console.log("slider", $(".slider"));
    await Service.analytics.sendPageView({
      path: this.$route.path,
    });

    console.log("powerBiDataOverviewCountry", this.powerBiDataOverviewCountry);
    console.log("powerBiDataOverviewInternational", this.powerBiDataOverviewInternational);
    await this.initData();
    // this.getArticles();
    this.isLoading = false;
  },
  beforeUpdate() {
    document.getElementsByTagName("iframe").forEach((element) => {
      element.classList.add("responsive-iframe");
    });
  },
  methods: {
    ...mapActions("overview", ["onGetAllDataTopic"]),
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    async initData() {
      this.isLoading = true;
      this.interPowerBiTopic = "international-power-bi-topic";
      this.countryPowerBiTopic = "country-power-bi-topic";
      this.isLoading = false;
    },

    async createPowerBi(power_bi, div_id) {
      let models = pbi.models;
      let permissions = models.Permissions.All;
      var config = {
        type: "report",
        tokenType: models.TokenType.Embed,
        accessToken: power_bi.access_token,
        embedUrl: power_bi.embed_url,
        id: power_bi.report_id,
        permissions: permissions,
        settings: {
          panes: {
            filters: {
              visible: true,
            },
            pageNavigation: {
              visible: true,
            },
          },
        },
      };

      let embedContainer = document.getElementById(div_id);
      let report = powerbi.embed(embedContainer, config);
      report.off("loaded");
      report.on("loaded", function () {
        console.log("Loaded");
      });
      report.off("rendered");
      report.on("rendered", function () {
        console.log("Rendered");
      });
      report.on("error", function (event) {
        console.log(event.detail);
        report.off("error");
      });
      report.off("saved");
      report.on("saved", function (event) {
        console.log(event.detail);
        if (event.detail.saveAs) {
          console.log(
              "In order to interact with the new report, create a new token and load the new report"
          );
        }
      });
    },
    createPowerBiDashboard(power_bi, div_id) {
      let models = pbi.models;

      let config = {
        type: "dashboard",
        tokenType: models.TokenType.Embed,
        accessToken: power_bi.access_token,
        embedUrl: power_bi.embed_url,
        id: power_bi.report_id,
        settings: {
          layoutType: models.LayoutType.Custom,
          customLayout: {
            displayOption: models.DisplayOption.FitToPage,
          },
        },
        pageView: "fitToWidth",
      };

      let dashboardContainer = document.getElementById(div_id);
      let dashboard = powerbi.embed(dashboardContainer, config);
      dashboard.off("loaded");
      dashboard.on("loaded", function () {
        console.log("Loaded");
      });
      dashboard.on("error", function (event) {
        console.log(event.detail);

        dashboard.off("error");
      });
      dashboard.off("tileClicked");
      dashboard.on("tileClicked", function (event) {
        console.log(event.detail);
      });
    },
    getArticles() {
      Service.webdata.getArticlesMode("overview").then((res) => {
        this.articles = res.data.map((item) => {
          return {
            ...item,
            img_cover_path:
                "https://data.cea.or.th/service" + "/" + item.img_cover_path,
          };
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tabSection {
  border-top: 1px solid #ff5100;
  border-bottom: 1px solid #ff5100;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-size: 20px;
  font-weight: bold;
  color: #ff5100;
  user-select: none;
  cursor: pointer;
}

.tabSection-mobile {
  font-size: 16px;
}

.tabActive {
  background: #ff5100;
  color: #fff;
}

.txtDetail {
  font-size: 18px;
  font-weight: bold;
  color: #1d1d1b;
  width: 100%;
}

.categoryIcon {
  user-select: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #ff5100;
  cursor: pointer;
  width: 143px;
  height: 150px;
  align-items: center;
}

.categoryIcon img {
  width: 55px;
  margin-bottom: 10px;
}

.categoryIcon:hover {
  background: rgba(255, 81, 0, 0.15);
}

.categoryIconHover:hover,
.categoryIconHover {
  background: rgba(255, 81, 0, 0.35);
}

.headTab {
  background: #000;
  color: #fff;
  text-transform: uppercase;
  font-size: 20px;
  display: flex;
  align-items: center;
}

.tableHeadTab {
  background: #000;
  color: #fff;
  text-transform: uppercase;
  font-size: 28px;
  display: flex;
}

.tableTxt {
  font-size: 17px;
  color: #fff !important;
}

th.tdHead {
  background-color: #ff5100;
  font-size: 15px;
  color: #fff;
}

/*.theme--light.v-data-table tbody th {*/
/*    position: -webkit-sticky !important; !* for Safari *!*/
/*    position: sticky !important;*/
/*    left: 0 !important;*/
/*}*/

/*.themem--light.v-data-table thead th:first-child {*/
/*    position: -webkit-sticky !important; !* for Safari *!*/
/*    position: sticky !important;*/
/*    left: 0;*/
/*    z-index: 1;*/
/*}*/

.theme--light.v-data-table thead tr th,
.theme--light.v-data-table tbody tr td {

  &:nth-child(1),
  &:nth-child(2) {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
  }

  &:nth-child(2) {
    left: 146.4px;
  }
}

.theme--light.v-data-table thead tr th {
  background-color: #000;
}

.theme--light.v-data-table tbody tr td {
  background-color: #fff;
}

.theme--light.v-data-table tbody th:first-child {
  position: -webkit-sticky;
  position: sticky;
  left: 0;
}

/* table border style */
.theme--light.v-data-table tbody tr td {
  border-bottom: 1px solid #ff5100 !important;
}

.theme--light.v-data-table thead tr th:nth-child(odd):not(:first-child),
.theme--light.v-data-table tbody tr td:nth-child(odd):not(:first-child) {
  color: #ff5100 !important;
}

.theme--light.v-data-table tbody tr td:not(:last-child),
.theme--light.v-data-table thead tr:last-child th:not(:last-child) {
  border-right: 1px solid #ff5100;
}


/* end table border style */
</style>
